export default function () {
  this.$emit('clicked')
}


// WEBPACK FOOTER //
// ./src/utils/emit_clicked.js